import React from 'react';
import {
  NavigationMenu,
  NavigationMenuItem, NavigationMenuLink,
  NavigationMenuList,
} from "@/components/ui/navigation-menu";
import {Avatar, AvatarFallback, AvatarImage} from "@/components/ui/avatar";
import {cn} from "@/lib/utils";
import {AvatarAndLineSkeleton, AvatarAndTwoLineSkeleton} from "@/components/common/skeletons";
import {NAVIGATION_ITEMS} from "@/constants/constants";
import {useIntl} from "react-intl";
import {Link, useLocation} from "react-router-dom";
import {appInfoStore, userStore} from "@/store/newStores";
import {urlLocations} from "@/routes/urlLocations";
import {FaRegUser} from "react-icons/fa6";
// import { RiArrowDropDownLine as DropDownIcon} from "react-icons/ri";
import {MdKeyboardArrowDown as DropDownIcon} from "react-icons/md";
import {DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger} from "@/components/ui/dropdown-menu";
import {useDispatch} from "react-redux";
import {logoutAction} from "@/services/logout/logout.action";

function ChurchHeader() {
  const userInfo = userStore.user.use();
  const isLoading = userStore.loading.use();
  const emirate = appInfoStore.emirates.get()[userInfo?.church?.emirate as string];

  return isLoading ? (<AvatarAndTwoLineSkeleton/>) : (
    <Link to={urlLocations.dashboard} className="flex items-center pe-2 gap-2 md:gap-4 text-white hover:text-white">
      <Avatar className="border-2 border-white w-12 h-12">
        <AvatarImage src={userInfo?.church?.logo?.url} alt="St. George and St. Anthony"/>
        <AvatarFallback className="bg-slate-300">SG</AvatarFallback>
      </Avatar>
      <div className="flex flex-col">
        <span className="text-base font-semibold">{userInfo?.church?.name}</span>
        <span
          className="text-sm opacity-50 hidden sm:block">{userInfo?.church?.addressLine} - {emirate?.name} - UAE</span>
      </div>
    </Link>
  );
}

const MenuItems = () => {
  const {pathname} = useLocation();
  const intl = useIntl();
  const userInfo = userStore.user.use();

  return <NavigationMenu className={"ml-10 mr-auto hidden md:block h-16"}>
    <NavigationMenuList className={"h-16"}>
      {NAVIGATION_ITEMS.map((item) => (
        <NavigationMenuItem key={item.dataKey} className={"h-full"}>
          <NavigationMenuLink
            className={cn(
              "group inline-flex h-full w-max items-center justify-center px-4 text-base text-white hover:text-white font-medium transition-colors hover:bg-white/10 focus:bg-white/10 focus:outline-none",
              pathname === item.to && "border-b-4 border-sky-500 bg-white/10 font-bold",
              (!item.access && !userInfo?.access?.[item.accessKey]) && "pointer-events-none opacity-50"
            )}
            active={pathname === item.to}
            href={item.to}>
            {intl.formatMessage({id: `Dashboard.${item.dataKey}.Title`})}
          </NavigationMenuLink>
        </NavigationMenuItem>
      ))}
    </NavigationMenuList>
  </NavigationMenu>;
};

function UserHeader() {

  const userInfo = userStore.user.use();
  const isLoading = userStore.loading.use();

  const dispatch = useDispatch();

  return isLoading ? (<AvatarAndLineSkeleton/>) :
    (
      <DropdownMenu>
        <DropdownMenuTrigger>
          <div className={"flex items-center gap-2 md:gap-4"}>
            <Avatar className={"border-2 border-white"}>
              <AvatarFallback className={"bg-slate-300 text-white"}><FaRegUser/></AvatarFallback>
            </Avatar>
            <span className={"text-sm text-white hidden md:block"}>{userInfo?.email}</span>
            <DropDownIcon className={"text-white"}/>
          </div>
        </DropdownMenuTrigger>
        <DropdownMenuContent align={"end"}>
          <DropdownMenuItem onClick={() => dispatch(logoutAction())}>Logout</DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    );
}

const HeaderNew = () => {
  return (
    <header className={"top-0 z-50 w-full border-b bg-gradient-blue text-white"}>
      <div className={"flex flex-row w-full h-16 px-4 md:px-8 items-center justify-between md:flex-start"}>
        <ChurchHeader/>
        <MenuItems/>
        <UserHeader/>
      </div>
    </header>
  )
    ;
};

export default HeaderNew;
